import React, { ReactElement, useContext, forwardRef } from "react";
import { MenuItem } from "./menu-item";
import { PanelMenuProps } from "./panel-menu.types";
import { NavContext } from "./navContext";
import { renderMenuItem } from "./panel-menu-standalone";
import { findItem } from "./navReducer.utils";
import { HeaderMeasureHelper } from "./HeaderMeasureHelper";

export const PanelMenuHeader = forwardRef<HTMLUListElement, PanelMenuProps>(
  ({ _privateProps = {} }, navListRef) => {
    const { isHeaderSecondary, moreNavAriaLabel } = _privateProps;

    const {
      state: { navTree, navTreeSecondary, measureInProgress, activeItem },
    } = useContext(NavContext);

    const renderMenuSecondaryList = (): ReactElement => (
      <ul ref={navListRef} className="spark-menu__list">
        {navTreeSecondary.map((item) => renderMenuItem(item, true, true))}
      </ul>
    );

    const renderMenuList = (): ReactElement => {
      const visibleHeaderItems = navTree?.filter(
        (item) => item._privateProps?.visible === true
      );

      const hiddenHeaderItems =
        visibleHeaderItems.length !== navTree.length
          ? navTree?.filter((item) => !item._privateProps?.visible)
          : [];

      return (
        <>
          {measureInProgress ? (
            <HeaderMeasureHelper />
          ) : (
            <ul
              ref={navListRef}
              className="spark-menu__list spark-header__list spark-header__list--overflow"
            >
              {visibleHeaderItems.map((item) =>
                renderMenuItem(item, true, false)
              )}
              {hiddenHeaderItems.length ? (
                <MenuItem
                  title={moreNavAriaLabel || ""}
                  _privateProps={{
                    isHeader: true,
                    isMoreNavItem: true,
                    isMoreNavItemActive: Boolean(
                      activeItem && findItem(hiddenHeaderItems, activeItem)
                    ),
                  }}
                >
                  {hiddenHeaderItems.map((item) => {
                    const moreNavChild = true;
                    return renderMenuItem(item, true, false, moreNavChild);
                  })}
                </MenuItem>
              ) : null}
            </ul>
          )}
        </>
      );
    };

    return isHeaderSecondary ? renderMenuSecondaryList() : renderMenuList();
  }
);

PanelMenuHeader.displayName = "PanelMenuHeader ";
